import React, { useState } from 'react'
import PageHeader from '../../components/Typography/PageHeader'
import ToolbarButton from '../../components/DataTable/ToolbarButton'
import LockPersonOutlinedIcon from '@mui/icons-material/LockPersonOutlined'
import { useAuth } from '../../applications/hooks/UseAuth'
import DataSetsService from './services/DataSets'
import DataSetsList from './components/DataSetsList'
import { AddDataSets } from './components/AddDataSets'
// import RolesList from '../users/components/roles/RoleList'

export const DataSets = () => {
    const { haveAccessTo } = useAuth()
    const [needLoad, setNeedLoad] = useState(true)
    const useDrawer = false
    const service = DataSetsService.load()

    const CURRENT_PAGE = 'administration_roles'

    return (
        <div className={'card w-full bg-base-100'} style={{ paddingBottom: 20 }}>
            <PageHeader
                title={'Gestion des données de base'}
                subTitle={'Gestion des Bases de données'}
                icon={<LockPersonOutlinedIcon color="primary" fontSize="large" />}
            >
                {' '}
                <ToolbarButton
                    moduleTitle="données de base"
                    service={service}
                    drawer={useDrawer}
                    haveAccessTo={haveAccessTo}
                    currentPage={CURRENT_PAGE}
                    setNeedLoad={setNeedLoad}
                    needLoad={needLoad}
                    Form={AddDataSets}
                />
            </PageHeader>
            <DataSetsList
                service={service}
                drawer={useDrawer}
                Form={AddDataSets}
                haveAccessTo={haveAccessTo}
                currentPage={CURRENT_PAGE}
                setNeedLoad={setNeedLoad}
                needLoad={needLoad}
            />
        </div>
    )
}
